<div
  tabindex="-1"
  aria-hidden="true"
  #modalDialogTemplate
  class="fixed bottom-0 left-0 right-0 top-0 z-100 hidden h-screen w-screen bg-system-backdrop-fill"
>
  <!-- Mobile version -->
  <div class="absolute top-1/2 mx-40 block max-w-[440px] -translate-y-1/2 sm:hidden">
    @if (isOpen) {
      <div
        class="relative flex w-full flex-col items-start justify-between gap-y-40 rounded-t-12 border-x-0.5 border-t-0.5 border-secondary-greys-50 bg-secondary-greys-white shadow-dialog-mogal"
      >
        <div
          class="absolute left-1/2 top-[-16px] -translate-x-1/2 rounded-2 border-3 border-secondary-greys-white p-4"
          [ngClass]="{
            'bg-secondary-crimson-50': type() === 'negative',
            'bg-brand-50': type() === 'info'
          }"
        >
          <svg-icon [src]="icon()"></svg-icon>
        </div>
        <div class="flex h-56 w-full items-center justify-end border-b-0.7 border-secondary-greys-50 px-16">
          @if (closeButton()) {
            <div class="w-fit">
              <app-tooltip body="Close">
                <app-button-secondary
                  [ghost]="true"
                  icon="images/Cancel_24px.svg"
                  (buttonClicked)="close()"
                ></app-button-secondary>
              </app-tooltip>
            </div>
          }
        </div>
        <div class="flex flex-col items-center justify-center gap-16 px-24">
          <div class="text-center text-display-xs-500 text-secondary-greys-black">
            {{ title() }}
          </div>
          <div class="text-center text-body-md-400 text-secondary-greys-900">
            {{ description() }}
          </div>
        </div>
        <div class="flex w-full flex-wrap justify-around gap-12 px-16 pb-16 pt-8">
          <app-button-secondary
            class="grow"
            [label]="buttonCancelLabel()"
            (buttonClicked)="onCancelClicked()"
          ></app-button-secondary>
          <app-button-primary
            class="grow"
            [type]="type() === 'negative' ? 'negative' : 'default'"
            [label]="buttonConfirmLabel()"
            (buttonClicked)="onConfirmClicked()"
          ></app-button-primary>
        </div>
      </div>
    }
  </div>

  <!-- Desktop version -->
  <div class="absolute top-[200px] hidden sm:block">
    @if (isOpen) {
      <div
        class="relative flex h-[300px] w-[440px] flex-col items-start justify-between rounded-tl-12 rounded-tr-12 border-0.5 border-secondary-greys-50 bg-secondary-greys-white shadow-dialog-mogal"
      >
        <div
          class="absolute left-[196px] top-[-16px] rounded-2 border-3 border-secondary-greys-white p-4"
          [ngClass]="{
            'bg-secondary-crimson-50': type() === 'negative',
            'bg-brand-50': type() === 'info'
          }"
        >
          <svg-icon [src]="icon()"></svg-icon>
        </div>
        <div class="flex h-56 w-full items-center justify-end border-b-0.7 border-secondary-greys-50 px-24">
          @if (closeButton()) {
            <div class="w-fit">
              <app-tooltip body="Close">
                <app-button-secondary
                  [ghost]="true"
                  icon="images/Cancel_24px.svg"
                  (buttonClicked)="close()"
                ></app-button-secondary>
              </app-tooltip>
            </div>
          }
        </div>
        <div class="flex flex-col items-center justify-center gap-16 px-24">
          <div class="text-center text-display-xs-500 text-secondary-greys-black">
            {{ title() }}
          </div>
          <div class="text-center text-body-md-400 text-secondary-greys-900">
            {{ description() }}
          </div>
        </div>
        <div class="flex w-full items-center gap-16 px-24 pb-24">
          <app-button-secondary
            class="grow"
            [label]="buttonCancelLabel()"
            (buttonClicked)="onCancelClicked()"
          ></app-button-secondary>
          <app-button-primary
            class="grow"
            [type]="type() === 'negative' ? 'negative' : 'default'"
            [label]="buttonConfirmLabel()"
            (buttonClicked)="onConfirmClicked()"
          ></app-button-primary>
        </div>
      </div>
    }
  </div>
</div>
